import React, { useState } from 'react';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { UiButton } from '../../../ui/ui-button';

import { MessageType } from '../../../util/message-types';

const EMPLOYEE_VARIABLES = [
  {
    label: 'Employee first name',
    value: '{{{employee.firstName}}}',
  },
  {
    label: 'Employee causal name (uses nickname)',
    value: '{{{employee.casualName}}}',
  },
  {
    label: 'Employee last name',
    value: '{{{employee.lastName}}}',
  },
  {
    label: 'Employee job title',
    value: '{{{employee.jobTitle}}}',
  },
  {
    label: 'Referral link',
    value: '{{{employee.referralLink}}}',
  },
  {
    label: 'Company name',
    value: '{{{employee.companyName}}}',
  },
  {
    label: 'Years employed description',
    value: '{{{employee.yearsEmployed}}}',
  },
];

const APPLICANT_VARIABLES = [
  {
    label: 'Applicant first name',
    value: '{{{applicant.firstName}}}',
  },
  {
    label: 'Applicant last name',
    value: '{{{applicant.lastName}}}',
  },
  {
    label: "Applicant's work history form",
    value: '{{{applicant.applicationWorkHistoryLink}}}',
  },
  {
    label: 'Job title',
    value: '{{{job.title}}}',
  },
  {
    label: 'Company name',
    value: '{{{job.companyName}}}',
  },
  {
    label: 'User first name',
    value: '{{{user.firstName}}}',
  },
  {
    label: 'User last name',
    value: '{{{user.lastName}}}',
  },
];

type InputProps = {
  onVariableSelect: (variableValue: string) => void;
  messageType: MessageType;
  recipientType: ContactType;
  style?: React.CSSProperties;
  /**
   * data-cy attribute on the personalize button to select
   * this button in end-to-end tests with Cypress
   * @default personalize
   */
  buttonDataCy?: string;
};

export const PersonalizeButton = ({
  onVariableSelect,
  recipientType,
  style,
  buttonDataCy = 'personalize',
}: InputProps) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.target as Element);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleVariableClick = (variableValue: string) => () => {
    onVariableSelect(variableValue);
    setAnchorEl(null);
  };

  const handleMoreClick = () => {
    window.open(
      'https://help.teamengine.io/article/36-using-variables-to-personalize-messages',
      '_blank',
    );
  };

  const variables = recipientType === 'applicant' ? APPLICANT_VARIABLES : EMPLOYEE_VARIABLES;

  return (
    <div style={style}>
      <UiButton onClick={handleOpenMenu} variant="tertiary" size="xxs" dataCy={buttonDataCy}>
        Personalize
      </UiButton>
      <Menu open={Boolean(anchorEl)} onClose={handleCloseMenu} anchorEl={anchorEl}>
        {variables.map((variable) => (
          <MenuItem
            key={variable.value}
            onClick={handleVariableClick(variable.value)}
            data-cy={`personalize-option-${variable.label}`}
          >
            {variable.label}
          </MenuItem>
        ))}
        <MenuItem onClick={handleMoreClick}>More...</MenuItem>
      </Menu>
    </div>
  );
};
